var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentTeam != null)?_c('div',{staticClass:"team-info"},[_c('span',{staticClass:"team-members"},[_vm._v(_vm._s(_vm.membersText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }